import { ActionType } from '../infrastructure/actionTypes';
import { ISeedProduct } from '../infrastructure/interfaces';

export default (list: ISeedProduct[] = [], action: any) => {
  switch (action.type) {
    case ActionType.GET_SEEDS_DONE:
      const { seeds } = action;
      let updatedList = seeds.map((seed: ISeedProduct) => ({...seed, isNew: seed.isNew || false, type: 'Seed'}));
      return updatedList.sort((a : {}, b: {}) => a['name'].localeCompare(b['name']));
    default:
      return list.sort((a : {}, b: {}) => a['name'].localeCompare(b['name']));
  }
};



// WEBPACK FOOTER //
// ./src/reducers/seedList.ts